import cc from 'classcat';

import { fromCents } from '#src/lib/formatters/numbers';
import BorderedRow from '#src/components/BorderedRow';
import AddPromoCode from '#src/components/AddPromoCode';

import styles from './styles.module.scss';

const Total = ({
  theme,
  content: { amountDueLabel },
  orderId,
  amountDue,
  hidePromoForm,
  onPromoError,
  className,
}) => (
  <BorderedRow className={cc([styles.container, className])}>
    <div
      className={cc([
        styles.addPromo,
        {
          [styles.hideAddPromo]: hidePromoForm,
        },
      ])}
    >
      <AddPromoCode
        theme={theme}
        orderId={orderId}
        linkClass={styles.addPromoLink}
        formClass={styles.addPromoForm}
        onError={onPromoError}
      />
    </div>
    <span className={styles.total}>
      {amountDueLabel}: <strong>{fromCents(amountDue)}</strong>
    </span>
  </BorderedRow>
);

export default Total;
